import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import HelperService from "../services/helper-service";
import EventAttendanceControl from "./event-attendance-control";
import {useAuth} from "../context/auth";
import FormatService from "../services/format-service";

export default function EventScheduleCell({event, trainer, link=null, mode="schedule", classes='', linkReplace="EID", callback = null, ...props}) {

    const [isPast, setIsPast] = useState(false);
    const dayjs = HelperService.getDayjs();
    const auth = useAuth();

    useEffect(() => {
        if (event?.datetime && event?.timezone && event?.duration){
            let eventEnd = dayjs(event?.datetime, 'x').tz(event?.timezone).add(event.duration, 'm');
            setIsPast(eventEnd<dayjs());
        }
    }, [event]);

    const PopupBadge = function({popup}){
        return <>{popup && <div className="p-2 bg-light fs-8 text-uppercase">Pop-Up | SUB</div>}</>
    }

    const EventScheduleCellCard = function () {

        const isCotrainer = event?.attendance?.isCotrainer || event.cotrainers?.some(att=>att?.trainer?.id===trainer?.id);
        const availablePlaces = HelperService.getEventSpotsLeft(event.capacity);

        return <div className={`card border-0 border-bottom overflow-hidden ${classes}`} onClick={callback ? () => callback(event) : undefined}>
            <div className="d-flex justify-content-between align-items-center flex-wrap">
                <div className="d-flex justify-content-between align-items-center flex-nowrap">

                    <div className="d-flex align-items-center justify-content-center flex-grow-0 flex-shrink-0" style={{width: '100px'}}>
                        <div className="p-1 p-sm-2 d-flex flex-column align-items-center justify-content-center gap-1 fs-7">
                            <div>{dayjs(event?.datetime, 'x').tz(event?.timezone).format('h:mm A')}</div>
                            <div className="text-secondary">{dayjs(event?.datetime, 'x').tz(event?.timezone).add(event.duration, 'm').format('h:mm A')}</div>
                            <div className="text-secondary">{HelperService.getEventOffsetString(event?.datetime, event?.timezone)}</div>
                        </div>

                        <div className={'align-self-stretch align-self-end py-2 px-1'}>
                            <div className={`${isPast ? 'bg-secondary' : 'bg-primary'} rounded-1`} style={{height: '100%', width: '4px'}}></div>
                        </div>
                    </div>


                    <div className="d-flex flex-grow-1">
                        <div className="p-2 p-md-3">
                            <h6>{event?.course?.name}</h6>
                            {event?.place && <div className="text-secondary fs-7 mb-2">
                                <span
                                    className="mdi mdi-map-marker-outline"></span> {event?.place?.name}{HelperService.getDistance(event?.place?.location) ? `, (${HelperService.getDistance(event?.place?.location)} mi)` : ''}
                                {event?.place?.location && <div
                                    className="text-secondary fs-7">{event.place.location.city && event.place.location.state ? `${event.place.location.city}, ${event.place.location.state}` : event.place.location.address}</div>}
                            </div>}

                            {(trainer?.name || event?.capacity) &&
                                <div className="text-secondary fs-7 mb-2">
                                    {isPast && <>
                                        <><span className="text-success text-uppercase fs-7">Ended</span> &nbsp;&nbsp;·&nbsp;&nbsp;</>
                                    </>}
                                    {!isPast && <>
                                        {mode === 'schedule' && <>
                                            {event?.removed && <><><span className="text-danger text-uppercase fs-7">Canceled class</span> &nbsp;&nbsp;·&nbsp;&nbsp;</>
                                            </>}
                                            {!event?.removed && <>
                                                {event?.attendance && !event?.attendance?.isCancelled && !event?.removed && <>
                                                    {!isCotrainer && <span className="text-success text-uppercase fs-7">Attending as participant</span>}
                                                    {isCotrainer && <span className="text-primary text-uppercase fs-7">Co-instructing</span>}
                                                    &nbsp;&nbsp;·&nbsp;&nbsp;
                                                </>}
                                                {event?.attendance?.isCancelled && !event?.attendance?.isRefundRequested && <><span
                                                    className="text-danger text-uppercase fs-7">Canceled as participant</span> &nbsp;&nbsp;·&nbsp;&nbsp;</>}
                                                {event?.attendance?.isRefundRequested && <><span className="text-danger text-uppercase fs-7">Refund requested</span> &nbsp;&nbsp;·&nbsp;&nbsp;</>}
                                                {!event?.attendance && auth?.currentUser?.id === trainer?.id && <><span
                                                    className="text-primary text-uppercase fs-7">Instructing</span> &nbsp;&nbsp;·&nbsp;&nbsp;</>}
                                                {!event?.attendance && auth?.currentUser?.id !== trainer?.id && trainer?.name && <><span className="text-primary text-uppercase fs-7">{trainer?.name} is instructing</span> &nbsp;&nbsp;·&nbsp;&nbsp;</>}
                                            </>}

                                        </>}
                                        {mode === 'trainerDetail' && <>
                                            {auth?.currentUser?.id !== trainer?.id && <>
                                                {!event?.removed && <>
                                                    {event?.subbed && <>
                                                        <span className="text-danger text-uppercase fs-7">Subbed</span> &nbsp;&nbsp;·&nbsp;&nbsp;
                                                    </>}
                                                    {!event?.subbed && <>
                                                        {trainer?.id == event?.trainer?.id && <><span
                                                            className="text-primary text-uppercase fs-7">{trainer?.name} is instructing</span> &nbsp;&nbsp;·&nbsp;&nbsp;</>}
                                                        {trainer?.id !== event?.trainer?.id && <>
                                                            {!isCotrainer && <span className="text-success text-uppercase fs-7">{trainer?.name} is attending</span>}
                                                            {isCotrainer && <span className="text-primary text-uppercase fs-7">{trainer?.name} is Co-instructing</span>}
                                                            &nbsp;&nbsp;·&nbsp;&nbsp;
                                                        </>}
                                                    </>}
                                                </>}
                                                {event?.removed && <><><span className="text-danger text-uppercase fs-7">Cancelled class</span> &nbsp;&nbsp;·&nbsp;&nbsp;</>
                                                </>}
                                            </>}
                                            {auth?.currentUser?.id === trainer?.id && <>
                                                {!event?.removed && <><><span className="text-primary text-uppercase fs-7">Instructing</span> &nbsp;&nbsp;·&nbsp;&nbsp;</>
                                                </>}
                                                {event?.removed && <><><span className="text-danger text-uppercase fs-7">Cancelled class</span> &nbsp;&nbsp;·&nbsp;&nbsp;</>
                                                </>}
                                            </>}
                                        </>}
                                    </>}

                                    {event?.capacity &&
                                        <span>{availablePlaces === null ? 'Unlimited capacity' : `${availablePlaces} ${FormatService.pluralify(availablePlaces, 'spot', 'spots', 'spots')} left`}</span>}
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-self-center flex-wrap mb-2">
                    {event?.special && <div className="p-1 p-sm-2 p-md-3">
                        <PopupBadge popup={event?.special || event?.subbed}/>
                    </div>}
                    <div className="p-1 p-sm-2 p-md-3">&nbsp;</div>
                </div>

                <div className="d-flex justify-content-between align-self-center flex-wrap mb-2">
                    {event?.capacity && !isPast &&
                        <div className="p-1 p-sm-2 p-md-3 z-3">
                            <EventAttendanceControl capacity={event?.capacity} attendance={event?.attendance} price={event?.price} id={event?.id} trainerId={trainer?.id} event={event}/>
                        </div>}
                    {link && event?.id && <Link className="text-decoration-none stretched-link" to={link.replace(linkReplace, event?.id)}></Link>}
                </div>

            </div>
        </div>
    }

    return <EventScheduleCellCard/>;
}
